// GENERATED from packages/tokens/tokens.json — do not edit. Run `pnpm tokens:build`.

/** Type presets published as `text-*` utilities; tailwind-merge treats these as font-size, not colour. */
export const TYPE_PRESETS = [
  'display',
  'page-title',
  'section',
  'card-title',
  'card-label',
  'row-title',
  'body',
  'body-sm',
  'meta',
  'meta-sm',
  'eyebrow',
  'timer',
  'timer-sm',
  'metric',
  'metric-sm',
  'cell',
  'inline-meta',
  'keycap',
] as const;
